// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import hopt from 'hola_opt';
import zutil from 'zutil';
import zurl from 'zurl';

interface i_use_rebranded_props {
    location?: Location;
    is_portal?: boolean;
}
export const use_rebranded = (props: i_use_rebranded_props = {})=>{
    const location = props.location || useLocation();
    const {pathname} = location;
    const state = useMemo(()=>{
        const qs = zurl.qs_parse(location.search.substr(1), {safe: true});
        if (qs.rebranding=='false')
            return false;
        if (qs.rebranding=='true')
            return true;
        const rebranded_pages = zutil.get(hopt, 'www_hola.rebranded', []);
        const page = rebranded_pages.find(p=>{
            return p.path?.includes(pathname) || p.path_re &&
                new RegExp(p.path_re).test(pathname);
        });
        if (page)
        {
            const {opt} = page;
            if (!opt)
                return true;
            return Object.keys(opt).every(p=>opt[p]===props[p]);
        }
        return false;
    }, [pathname, props.location, props.is_portal]);
    return state;
};
